import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import type { ClientAssetTranscriptionMatchInfoFragment } from '@frameio/graphql-client/generated';
import { ClientAssetTranscriptionMatchInfo } from '@frameio/graphql-client/generated';

export const useSetClientAssetTranscriptionMatch = () => {
  const { cache } = useApolloClient();

  return useCallback(
    (
      clientTranscriptMatch: Omit<
        ClientAssetTranscriptionMatchInfoFragment,
        '__typename'
      >
    ) => {
      cache.writeFragment({
        fragment: ClientAssetTranscriptionMatchInfo,
        fragmentName: 'ClientAssetTranscriptionMatchInfo',
        data: {
          __typename: 'ClientAssetTranscriptionMatch',
          id: clientTranscriptMatch.id,
          transcriptionId: clientTranscriptMatch.transcriptionId,
          term: clientTranscriptMatch.term,
        },
        broadcast: true,
        overwrite: true,
      });
    },
    [cache]
  );
};
